// Adds an accessible name to Adopt's cookie banner dialog and "powered by"
// link, since that markup is rendered by their 3rd-party script and we
// can't fix it at the source.
(function () {
  'use strict';

  var DIALOG_SELECTOR = '#cookie-banner[role="dialog"]';
  var BADGE_LINK_SELECTOR = 'a[href="https://www.becompliance.com"]';
  var DIALOG_FALLBACK_LABEL = 'Cookie consent';
  var BADGE_FALLBACK_LABEL = 'Powered by BeCompliance';
  var OBSERVER_TIMEOUT_MS = 15000;

  function isAdoptInjectorPresent() {
    return !!document.querySelector('script.adopt-injector');
  }

  function patchDialogName(dialog) {
    if (!dialog || dialog.hasAttribute('aria-label')) return;

    var labelledBy = dialog.getAttribute('aria-labelledby');
    var labelEl = labelledBy ? document.getElementById(labelledBy) : null;

    if (!labelEl || !labelEl.textContent.trim()) {
      dialog.setAttribute('aria-label', DIALOG_FALLBACK_LABEL);
    }
  }

  function patchBadgeLinks(root) {
    var links = root.querySelectorAll(BADGE_LINK_SELECTOR);

    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (!link.getAttribute('aria-label') && !link.textContent.trim()) {
        link.setAttribute('aria-label', BADGE_FALLBACK_LABEL);
      }
    }
  }

  function patchBannerIfPresent() {
    var dialog = document.querySelector(DIALOG_SELECTOR);
    if (!dialog) return false;

    patchDialogName(dialog);
    patchBadgeLinks(document);

    return true;
  }

  function watchForBanner() {
    if (typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function () {
      if (patchBannerIfPresent()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(function () {
      observer.disconnect();
    }, OBSERVER_TIMEOUT_MS);
  }

  function init() {
    try {
      if (!isAdoptInjectorPresent()) return;
      if (patchBannerIfPresent()) return;

      watchForBanner();
    } catch (error) {
      // Best-effort a11y patch for a 3rd-party widget: never surface errors.
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
